import React, { useState, useEffect, useRef } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getProblemImages } from '../../../../functions/get_problem';
import '../../../problem_screen/create_problem/create_problem.css';
import '../../../solution_screen/solution_implimentation/solution_imp.css';

export default function WizardProblemForm({ eventData, onDataChange, initialData }) {
    const [pickedPD, setPickedPD] = useState(initialData?.pickedPD || []);
    const [pickedPMT, setPickedPMT] = useState(initialData?.pickedPMT || []);
    const [showPD, setShowPD] = useState(false);
    const [showPMT, setShowPMT] = useState(false);
    const pdDropdownRef = useRef(null);
    const pmtDropdownRef = useRef(null);

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pdDropdownRef.current && !pdDropdownRef.current.contains(event.target)) {
                setShowPD(false);
            }
            if (pmtDropdownRef.current && !pmtDropdownRef.current.contains(event.target)) {
                setShowPMT(false);
            }
        };

        if (showPD || showPMT) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPD, showPMT]);

    // Notify parent of data changes
    useEffect(() => {
        if (onDataChange) {
            onDataChange({
                pickedPD,
                pickedPMT
            });
        }
    }, [pickedPD, pickedPMT, onDataChange]);

    const getSelectedPDText = () => {
        if (pickedPD.length === 0) return 'Select';
        if (pickedPD.length === 1) return pickedPD[0];
        return `${pickedPD.length} selected`;
    };

    const getSelectedPMTText = () => {
        if (pickedPMT.length === 0) return 'Select';
        if (pickedPMT.length === 1) return pickedPMT[0];
        return `${pickedPMT.length} selected`;
    };

    const togglePD = (item) => {
        if (pickedPD.includes(item)) {
            setPickedPD(pickedPD.filter(i => i !== item));
        } else {
            setPickedPD([...pickedPD, item]);
        }
    };

    const togglePMT = (item) => {
        if (pickedPMT.includes(item)) {
            setPickedPMT(pickedPMT.filter(i => i !== item));
        } else {
            setPickedPMT([...pickedPMT, item]);
        }
    };

    const domain = eventData?.eventType || 'Theory';
    const [problemImages, setProblemImages] = useState([]);
    const problemImagesSliderRef = useRef();

    useEffect(() => {
        // Get problem images from problem mapped to
        if (pickedPMT && pickedPMT.length > 0 && eventData?.eventType) {
            const images = getProblemImages(pickedPMT, eventData.eventType);
            setProblemImages(images);
        } else {
            setProblemImages([]);
        }
    }, [pickedPMT, eventData?.eventType]);

    const settingsSlick = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="wizard-problem-form">
            <div className="problem-view-container">
                <div className="problem-details-panel">
                    <div className="form-container">
                        <div className="form-column left-column">
                            <div className="form-field">
                                <label className="field-label">Event Name*</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={eventData?.eventName || ''}
                                    readOnly
                                />
                            </div>

                            <div className="form-field">
                                <label className="field-label">Problem Identified from Event*</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={eventData?.problem || ''}
                                    readOnly
                                />
                            </div>

                            <div className="form-field">
                                <label className="field-label">Problem Mapped To*</label>
                                <div ref={pmtDropdownRef} className={`custom-dropdown ${showPMT ? 'open' : ''}`}>
                                    <div className="dropdown-trigger" onClick={() => setShowPMT(!showPMT)}>
                                        <span className="dropdown-text">{getSelectedPMTText()}</span>
                                        <ExpandMoreIcon className={`dropdown-icon ${showPMT ? 'rotated' : ''}`} />
                                    </div>
                                    {showPMT && (
                                        <div className="dropdown-menu">
                                            {domain === 'Theory' ? (
                                                <>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregarding Application of Theory')}
                                                            onChange={() => togglePMT('Disregarding Application of Theory')}
                                                        />
                                                        <span>Disregarding Application of Theory</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misinterpretation of Theory')}
                                                            onChange={() => togglePMT('Misinterpretation of Theory')}
                                                        />
                                                        <span>Misinterpretation of Theory</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Error in Presentation of Theory or Improper Presentation of Theory')}
                                                            onChange={() => togglePMT('Error in Presentation of Theory or Improper Presentation of Theory')}
                                                        />
                                                        <span>Error in Presentation of Theory or Improper Presentation of Theory</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Importance of Theory')}
                                                            onChange={() => togglePMT('Disregard Importance of Theory')}
                                                        />
                                                        <span>Disregard Importance of Theory</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Relationship of Theory and Theory of Communication')}
                                                            onChange={() => togglePMT('Disregard Relationship of Theory and Theory of Communication')}
                                                        />
                                                        <span>Disregard Relationship of Theory and Theory of Communication</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Portability of Theory')}
                                                            onChange={() => togglePMT('Disregard Portability of Theory')}
                                                        />
                                                        <span>Disregard Portability of Theory</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Theory and System Relationship')}
                                                            onChange={() => togglePMT('Disregard Theory and System Relationship')}
                                                        />
                                                        <span>Disregard Theory and System Relationship</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Independency of Theory')}
                                                            onChange={() => togglePMT('Disregard Independency of Theory')}
                                                        />
                                                        <span>Disregard Independency of Theory</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Expandability of Philosophy')}
                                                            onChange={() => togglePMT('Expandability of Philosophy')}
                                                        />
                                                        <span>Expandability of Philosophy</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misapplication of Instruments')}
                                                            onChange={() => togglePMT('Misapplication of Instruments')}
                                                        />
                                                        <span>Misapplication of Instruments</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misuse of Good Instruments')}
                                                            onChange={() => togglePMT('Misuse of Good Instruments')}
                                                        />
                                                        <span>Misuse of Good Instruments</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Instrument and System Relationship')}
                                                            onChange={() => togglePMT('Disregard Instrument and System Relationship')}
                                                        />
                                                        <span>Disregard Instrument and System Relationship</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard System and System Relationship')}
                                                            onChange={() => togglePMT('Disregard System and System Relationship')}
                                                        />
                                                        <span>Disregard System and System Relationship</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Function and System Relationship')}
                                                            onChange={() => togglePMT('Disregard Function and System Relationship')}
                                                        />
                                                        <span>Disregard Function and System Relationship</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misapplication of Method')}
                                                            onChange={() => togglePMT('Misapplication of Method')}
                                                        />
                                                        <span>Misapplication of Method</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Application of Bad Methods')}
                                                            onChange={() => togglePMT('Application of Bad Methods')}
                                                        />
                                                        <span>Application of Bad Methods</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard Method and System Relationship')}
                                                            onChange={() => togglePMT('Disregard Method and System Relationship')}
                                                        />
                                                        <span>Disregard Method and System Relationship</span>
                                                    </label>
                                                </>
                                            ) : (
                                                <>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Perform inappropriate actions')}
                                                            onChange={() => togglePMT('Perform inappropriate actions')}
                                                        />
                                                        <span>Perform inappropriate actions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about performing inappropriate actions')}
                                                            onChange={() => togglePMT('Communicate about performing inappropriate actions')}
                                                        />
                                                        <span>Communicate about performing inappropriate actions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misuse of instructions')}
                                                            onChange={() => togglePMT('Misuse of instructions')}
                                                        />
                                                        <span>Misuse of instructions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about misusing of instructions')}
                                                            onChange={() => togglePMT('Communicate about misusing of instructions')}
                                                        />
                                                        <span>Communicate about misusing of instructions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use inappropriate instructions')}
                                                            onChange={() => togglePMT('Use inappropriate instructions')}
                                                        />
                                                        <span>Use inappropriate instructions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about using inappropriate instructions')}
                                                            onChange={() => togglePMT('Communicate about using inappropriate instructions')}
                                                        />
                                                        <span>Communicate about using inappropriate instructions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard instructions')}
                                                            onChange={() => togglePMT('Disregard instructions')}
                                                        />
                                                        <span>Disregard instructions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about disregarding instructions')}
                                                            onChange={() => togglePMT('Communicate about disregarding instructions')}
                                                        />
                                                        <span>Communicate about disregarding instructions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misuse of objects')}
                                                            onChange={() => togglePMT('Misuse of objects')}
                                                        />
                                                        <span>Misuse of objects</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about misuse of objects')}
                                                            onChange={() => togglePMT('Communicate about misuse of objects')}
                                                        />
                                                        <span>Communicate about misuse of objects</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use inappropriate objects')}
                                                            onChange={() => togglePMT('Use inappropriate objects')}
                                                        />
                                                        <span>Use inappropriate objects</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about using inappropriate objects')}
                                                            onChange={() => togglePMT('Communicate about using inappropriate objects')}
                                                        />
                                                        <span>Communicate about using inappropriate objects</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misinformation')}
                                                            onChange={() => togglePMT('Misinformation')}
                                                        />
                                                        <span>Misinformation</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about misinformation')}
                                                            onChange={() => togglePMT('Communicate about misinformation')}
                                                        />
                                                        <span>Communicate about misinformation</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Misinterpretation')}
                                                            onChange={() => togglePMT('Misinterpretation')}
                                                        />
                                                        <span>Misinterpretation</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about Misinterpretation')}
                                                            onChange={() => togglePMT('Communicate about Misinterpretation')}
                                                        />
                                                        <span>Communicate about Misinterpretation</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Follow others')}
                                                            onChange={() => togglePMT('Follow others')}
                                                        />
                                                        <span>Follow others</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about following others')}
                                                            onChange={() => togglePMT('Communicate about following others')}
                                                        />
                                                        <span>Communicate about following others</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Miscommunication')}
                                                            onChange={() => togglePMT('Miscommunication')}
                                                        />
                                                        <span>Miscommunication</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about miscommunication')}
                                                            onChange={() => togglePMT('Communicate about miscommunication')}
                                                        />
                                                        <span>Communicate about miscommunication</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Exercise of force')}
                                                            onChange={() => togglePMT('Exercise of force')}
                                                        />
                                                        <span>Exercise of force</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about exercising of force')}
                                                            onChange={() => togglePMT('Communicate about exercising of force')}
                                                        />
                                                        <span>Communicate about exercising of force</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Disregard principles')}
                                                            onChange={() => togglePMT('Disregard principles')}
                                                        />
                                                        <span>Disregard principles</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Communicate about disregarding principles')}
                                                            onChange={() => togglePMT('Communicate about disregarding principles')}
                                                        />
                                                        <span>Communicate about disregarding principles</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use of bad words')}
                                                            onChange={() => togglePMT('Use of bad words')}
                                                        />
                                                        <span>Use of bad words</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use of bad expressions')}
                                                            onChange={() => togglePMT('Use of bad expressions')}
                                                        />
                                                        <span>Use of bad expressions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use of non-portable words')}
                                                            onChange={() => togglePMT('Use of non-portable words')}
                                                        />
                                                        <span>Use of non-portable words</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use of non-portable expressions')}
                                                            onChange={() => togglePMT('Use of non-portable expressions')}
                                                        />
                                                        <span>Use of non-portable expressions</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use of words with multiple meanings1')}
                                                            onChange={() => togglePMT('Use of words with multiple meanings1')}
                                                        />
                                                        <span>Use of words with multiple meanings</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Use of words with multiple meanings2')}
                                                            onChange={() => togglePMT('Use of words with multiple meanings2')}
                                                        />
                                                        <span>Use of words with multiple meanings</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Word matching error to form expression')}
                                                            onChange={() => togglePMT('Word matching error to form expression')}
                                                        />
                                                        <span>Word matching error to form expression</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Word does not match in sentence')}
                                                            onChange={() => togglePMT('Word does not match in sentence')}
                                                        />
                                                        <span>Word does not match in sentence</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Words do not identify actual entity')}
                                                            onChange={() => togglePMT('Words do not identify actual entity')}
                                                        />
                                                        <span>Words do not identify actual entity</span>
                                                    </label>
                                                    <label className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={pickedPMT.includes('Provide misinformation')}
                                                            onChange={() => togglePMT('Provide misinformation')}
                                                        />
                                                        <span>Provide misinformation</span>
                                                    </label>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="form-column right-column">
                            <div className="form-field">
                                <label className="field-label">Negative Function Executed*</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={eventData?.negative || ''}
                                    readOnly
                                />
                            </div>

                            <div className="form-field">
                                <label className="field-label">Principle Deficiency*</label>
                                <div ref={pdDropdownRef} className={`custom-dropdown ${showPD ? 'open' : ''}`}>
                                    <div className="dropdown-trigger" onClick={() => setShowPD(!showPD)}>
                                        <span className="dropdown-text">{getSelectedPDText()}</span>
                                        <ExpandMoreIcon className={`dropdown-icon ${showPD ? 'rotated' : ''}`} />
                                    </div>
                                    {showPD && (
                                        <div className="dropdown-menu">
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Communication Set')}
                                                    onChange={() => togglePD('The Communication Set')}
                                                />
                                                <span>The Communication Set</span>
                                            </label>
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Information Set')}
                                                    onChange={() => togglePD('The Information Set')}
                                                />
                                                <span>The Information Set</span>
                                            </label>
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Instrumentation Set')}
                                                    onChange={() => togglePD('The Instrumentation Set')}
                                                />
                                                <span>The Instrumentation Set</span>
                                            </label>
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Marketing Set')}
                                                    onChange={() => togglePD('The Marketing Set')}
                                                />
                                                <span>The Marketing Set</span>
                                            </label>
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Exchange Set')}
                                                    onChange={() => togglePD('The Exchange Set')}
                                                />
                                                <span>The Exchange Set</span>
                                            </label>
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Gaming Set')}
                                                    onChange={() => togglePD('The Gaming Set')}
                                                />
                                                <span>The Gaming Set</span>
                                            </label>
                                            <label className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={pickedPD.includes('The Work Set')}
                                                    onChange={() => togglePD('The Work Set')}
                                                />
                                                <span>The Work Set</span>
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {problemImages.length > 0 && (
                    <div className='problem-images-panel'>
                        <div className="images">
                            <h1 className='title'>Problem Mapped To</h1>
                            <Slider ref={problemImagesSliderRef} className='carasoul-box' {...settingsSlick}>
                                {problemImages.map((image, index) => (
                                    <div key={index} className="carousel-slide">
                                        <img alt={`Problem Mapped To ${index + 1}`} src={image} className="problem-image" />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// Export validation function
export const validateProblemForm = (problemData) => {
    if (!problemData.pickedPD || problemData.pickedPD.length === 0) {
        return { valid: false, message: 'pick Principal deficiency' };
    }
    if (!problemData.pickedPMT || problemData.pickedPMT.length === 0) {
        return { valid: false, message: 'pick Problem Mapped To' };
    }
    return { valid: true };
};
